/**
 * Responsible for creating an toggleContent based on elements existing in the DOM
 * @module toggleContent
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

const throttle = require('lodash/throttle');

const PLUGIN_NAME = 'lazyLoadImage';
const CLICK_EVENT = 'scroll.lazyloadimage';
// const ACTIVE_CLASS = 'is-active';

const DEFAULTS = {};

/**
 * Handles the click event when a label has been iteracted with.
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} opts - Options passed along from initialization
 */
function loadImage($el, opts, $window, windowBottomPosition, imagePosition, imageSrc) {
  if (windowBottomPosition >= imagePosition) {
    $el.attr('src', imageSrc);
    $el.attr('lazytriggeredimg', 'true');
  }
}
function checkLoadedImage($el, opts, $window) {
  const imageLoadedState = $el.attr('lazytriggeredimg');
  if (imageLoadedState === 'true') {
    $window.off(CLICK_EVENT);
  }
}

/**
 * Applies any sort of event handlers for the toggleContent.
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
function applyEventHandlers(
  $el,
  opts = {},
  $window,
  windowBottomPosition,
  imagePosition,
  imageSrc,
  ) {
  $window.on(CLICK_EVENT, throttle(() => {
    loadImage($el, opts, $window, windowBottomPosition, imagePosition, imageSrc);
    checkLoadedImage($el, opts, $window);
  }, 100));
}

/**
 * Initializes an toggleContent based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
function toggleDisplay(el, options = {}) {
  const $el = $(el);
  const $window = $(window);
  const opts = mergeOptions(DEFAULTS, options, $el);
  const windowHeight = $(window).height();
  const windowBottomPosition = $(window).scrollTop() + windowHeight;
  const imagePosition = $el.offset().top;
  const imageSrc = $el.attr('data-lazy-img');

  $el.attr('lazytriggeredimg', 'false');

  // $(window).off(CLICK_EVENT);
  applyEventHandlers(
      $el,
      opts,
      $window,
      windowBottomPosition,
      imagePosition,
      imageSrc,
      windowHeight,
    );
}

$.extend(toggleDisplay, {
  PLUGIN_NAME,
  CLICK_EVENT,
});

// Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, toggleDisplay);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/lazyload-image.js